import InputAdornment from '@mui/material/InputAdornment';
import InsertCommentIcon from '@mui/icons-material/InsertComment';
import Input from '@mui/material/Input';
// import logo from './logo.svg';
import logo from './logo.png';
import './App.css';
import React from 'react';
import { useParams } from "react-router-dom";
import Avatar from '@mui/material/Avatar';
import Stack from '@mui/material/Stack';
import Backdrop from '@mui/material/Backdrop';
import Box from '@mui/material/Box';
import Modal from '@mui/material/Modal';
import Fade from '@mui/material/Fade';import Card from '@mui/material/Card';
import CardActions from '@mui/material/CardActions';
import CardContent from '@mui/material/CardContent';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import Rating from '@mui/material/Rating';
import CenteredTabs from './questions.js'
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
import SendIcon from '@mui/icons-material/Send';
import Grid from '@mui/material/Unstable_Grid2'; // Grid version 2
import DownloadIcon from '@mui/icons-material/Download';
import Paper from '@mui/material/Paper';
import { createTheme, ThemeProvider, styled } from '@mui/material/styles';
import TextField from '@mui/material/TextField';
import axios from 'axios'
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Snackbar from '@mui/material/Snackbar';



const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: window.innerWidth-80,
  height: window.innerHeight-80,
  bgcolor: 'background.paper',
  border: '2px solid #000',
  boxShadow: 24,
  maxWidth: 500,
  textAlign: 'center',
  p: 4,
  overflowY: "auto",
  dir: 'rtl'

};

const selected = {borderColor:'#3aacd7', borderWidth: 2};
const unselected = {};
const good = [
  {id: 1, title: 'مراجعه به موقع تکنسین', selected: false},
  {id: 2, title: 'پاسخگویی خوب واحد خدمات', selected: false},
  {id: 3, title: 'هزینه مناسب خدمات', selected: false},
  {id: 4, title: 'کیفیت خوب کار', selected: false},
  {id: 5, title: 'رفتار محترمانه', selected: false},
]

const bad = [
  {id: 11, title: 'عدم مراجعه به موقع', selected: false},
  {id: 12, title: 'پاسخگویی بد واحد خدمات', selected: false},
  {id: 13, title: 'پیگیری نامناسب خدمات', selected: false},
  {id: 14, title: 'کیفیت نا مطلوب تکنسین', selected: false},
  {id: 15, title: 'هزینه بالای خدمات', selected: false},
]

function App() {
  const [value, setValue] = React.useState(0);
  const [explain, setExplain] = React.useState('');
  const [message, setMessage] = React.useState('');
  const [open, setOpen] = React.useState(false);
  const [e404, setE404] = React.useState(false);
  const [ratingDisable, setRatingDisable] = React.useState(false);
  const [openSn, setOpenSn] = React.useState(false);
  const [invoiceInformation, setInvoiceInformation] = React.useState({});
  const [agent, setAgent] = React.useState();
  const [goodOptions, setGoodOptions] = React.useState(good);
  const [badOptions, setBadOptions] = React.useState(bad);
 const handleOpen = () => setOpen(true);
 const handleClose = () => setOpen(false);
 const [value2, setValue2] = React.useState(0);
 const handleChange = (event: React.SyntheticEvent, newValue: number) => {
   setValue2(newValue);
 };
  const routeParams = useParams();

  const getInformation = async(invoiceNo) => {
    const response = await axios.post('https://api.fntpf.ir/rating/information', {invoiceNo});
    if(response.data.status){
      setRatingDisable(response.data.done)
      setValue(response.data.score)
      setAgent(response.data.queryResponse.agent);
      setInvoiceInformation(response.data.queryResponse.invoice)
      console.log(response.data.queryResponse.invoice);
    }
    else{
      setE404(true)
    }
  }
  React.useEffect(()=>{
    const invoiceNo =  (Number(routeParams.invoiceNo)/1375-5119)/1371;
    if(routeParams.invoiceNo) getInformation(invoiceNo)
  },[openSn])
  const renderSwitch =  (param)=>{
  switch (param) {
    case 1:
      return 'خیلی بد'
    case 2:
      return 'بد'
    case 3:
      return 'متوسط'
    case 4:
      return 'خوب'
    case 5:
      return 'عالی'
      break;
    default:
      return '-'
  }
}
const Item = styled(Paper)(({ theme }) => ({
  ...theme.typography.body2,
  textAlign: 'center',
  color: theme.palette.text.secondary,
  height: 60,
  lineHeight: '60px',
}));

const sendScore = async()=>{
  var data = {
    requestId: invoiceInformation.id,
    agentId: invoiceInformation.agent_id,
    score: value,
    comment: explain,
    scoreOptions: JSON.stringify([...goodOptions, ...badOptions])
  }
  console.log(data);
  const response = await axios.post('https://api.fntpf.ir/rating/insertscore', data);
  if(response.data.status) {
    console.log('OK');
    setMessage('با سپاس از همراهی شما')
    setOpenSn(true)
    setOpen(false)
  }
  else {
    console.log('Failed!');
    setMessage('عدم ارتباط با سرور، لطفا بعدا تلاش کنید.')
    setOpenSn(true)
  }
}
  return (
    <div style={{alignItems: 'center', textAlign: '-webkit-center' }}>
    <div className="App" dir='rtl'>
      <header className="App-header">
      <Box
     sx={{
       pt: 1,
       width: '-webkit-fill-available',
       height: 'auto',

     }}>
     <img src={logo} width={200}/>
     <p style={{marginTop:-5}}>فناوران نوین پارسیان تصویر فدک</p>
     <h4 style={{marginTop:-10}}>امتیاز به تکنسین</h4>
     <p style={{marginTop:-10, fontSize:'10px'}}>شماره قبض: {invoiceInformation.id?invoiceInformation.id:''}</p>
     </Box>
     { e404 ?      <h4 style={{marginTop:-10}}>صفحه مورد نظر وجود ندارد</h4>
 : <div>
        <Card sx={{width: '-webkit-fill-available', mt:2 }}>
          <CardContent>
          <Stack direction="row" spacing={2}>
             <Avatar
               alt="Remy Sharp"
               src={`https://api.fntpf.ir/assets/uploaded/images/${agent?agent.img_uri:'download.jpg'}`}
               sx={{ width: 72, height: 72, marginTop:20 }}
             />
             <div style={{marginRight:25, marginTop:-10, width:'100%'}}>
             <Grid container spacing={3}>
               <Grid item xs={6}>
                 <h4 style={{marginTop:5}}>
                   {agent ? `${agent.firstname} ${agent.lastname}` : ''}
                 </h4>
                 <p style={{fontSize: '12px', margin:0}}>
                   {invoiceInformation.completed_date? invoiceInformation.completed_date.split('T')[0] : ''}
                 </p>
               </Grid>
               <Grid item xs={6} >
                 <h4 style={{marginTop:5}}>
                 {`استان ${invoiceInformation.merchant_province ? invoiceInformation.merchant_province : ''}`}

                 </h4>
                 <p style={{fontSize: '12px', margin:0}}>
                   {`${invoiceInformation.service_type ? invoiceInformation.service_type : ''} ${invoiceInformation.product_category ? invoiceInformation.product_category : ''}`}
                 </p>
               </Grid>
             </Grid>

             </div>
           </Stack>

          </CardContent>
        </Card>
        <br />
        <Card sx={{width: '-webkit-fill-available', mt:2 }}>
          <CardContent>
            <Typography sx={{ fontSize: 14 }} color="text.secondary" gutterBottom>
            </Typography>
            <h3 variant="h5" component="div">
              به تکنسین امتیاز بدهید
            </h3>
            <p style={{fontSize: '14px'}}>
              خدمات ارائه شده چطور بود؟
            </p>
            <Rating
              dir='ltr'
              name="simple-controlled"
              value={value}
              size="large"
              disabled={ratingDisable}
              onChange={(event, newValue) => {
                setValue(newValue);
                handleOpen();
                if(newValue > 3) setValue2(1)
                else setValue2(0)
              }}
            />
            <h5>{renderSwitch(value)}</h5>
            <p style={{fontSize: '10px'}}>
              <VisibilityOffIcon fontSize="small" /> نظر شما درباره تکنسین محفوظ است.
            </p>
          </CardContent>
          <CardActions>
            <Button variant="contained" style={{width: '100%'}} onClick={()=>{window.open(`../admin/print/${routeParams.invoiceNo}`)}}>دانلود فاکتور</Button>
          </CardActions>
        </Card>
        </div>
      }
      </header>
    </div>
    <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        open={open}
        onClose={handleClose}
        closeAfterTransition
        style={{
        overflowY: "auto"
        }}
        slots={{ backdrop: Backdrop }}
        slotProps={{
          backdrop: {
            timeout: 500,
          },
        }}
      >
        <Fade in={open}>
        <Card sx={style}>
        <Rating
          dir='ltr'
          name="simple-controlled"
          value={value}
          size="large"
          onChange={(event, newValue) => {
            setValue(newValue);
            handleOpen();
            if(newValue > 3) setValue2(1)
            else setValue2(0)
          }}
        />
        <h5>{renderSwitch(value)}</h5>
          <Tabs value={value2} onChange={handleChange} variant="fullWidth">
            <Tab label="نقاط منفی" />
            <Tab label="نقاط مثبت" />
          </Tabs>
          { value2 == 1 &&
          <Grid container spacing={2} style={{textAlign:'center', marginTop:10}}>
               {good.map((item, index) => (
                 <Grid item xs={6} key={index}>
                 <Box
                   sx={{
                     display: 'flex',
                     '& > :not(style)': {
                       m: 1,
                       width: '100%',
                     },
                   }}
                 >
                   <Paper variant="outlined" elevation={4} onClick={()=>{
                     var nextList = [...goodOptions];
                     nextList[index].selected = !goodOptions[index].selected;
                     setGoodOptions(nextList)
                   }}
                     style={goodOptions[index].selected ? selected : unselected}>
                   <p style={{fontSize: '12px', margin:2, fontFamily: 'IRAN-sans'}}>
                   {item.title}
                   </p>
                   </Paper>
                 </Box>
                 </Grid>
               ))}
             </Grid>
          }
          { value2 == 0 &&
          <Grid container spacing={2} style={{textAlign:'center',  marginTop:10}}>
               {bad.map((item, index) => (
                 <Grid item xs={6} key={index}>
                 <Box
                   sx={{
                     display: 'flex',
                     '& > :not(style)': {
                       m: 1,
                       width: '100%',
                       pr: 1,
                       pl: 1
                     },
                   }}
                 >
                   <Paper variant="outlined" elevation={2} onClick={()=>{
                     var nextList = [...badOptions];
                     nextList[index].selected = !badOptions[index].selected;
                     setBadOptions(nextList)
                   }}
                     style={badOptions[index].selected ? selected : unselected}>
                   <p style={{fontSize: '12px', margin:2, fontFamily: 'IRAN-sans'}}>
                   {item.title}
                   </p>
                   </Paper>
                 </Box>
                 </Grid>
               ))}
             </Grid>
          }
          <Input style={{dir:'rtl', width: '100%', marginTop: 25}}
            multiline
            value= {explain}
            onChange={e => setExplain(e.target.value)}
            id="input-with-icon-adornment"
            placeholder='نوشتن نظر درباره این سفارش'
            startAdornment={
              <InputAdornment position="start">
                <InsertCommentIcon />
              </InputAdornment>
            }
          />
          <Grid container spacing={2} sx={{ mt:2 , mb:2}}>
            <Grid xs={8}>
              <Button style={{width: '100%'}} onClick={sendScore} variant="contained" endIcon={<SendIcon />}>ثبت</Button>
            </Grid>
            <Grid xs={4}>
              <Button style={{width: '100%'}} variant="outlined" endIcon={<DownloadIcon />} onClick={()=>{window.open(`https://panel.fntpf.ir/invoice/${routeParams.invoiceNo}`)}}>فاکتور</Button>
            </Grid>
          </Grid>
        </Card>
        </Fade>
      </Modal>
      <Snackbar open={openSn} message={message} autoHideDuration={6000}/>
    </div>
  );
}

export default App;
